<nb-layout>
  <nb-layout-header>
    <ngx-header></ngx-header>
  </nb-layout-header>
  <nb-layout-column>
    <section class="questioner-content">
      <div class="container">
        <div class="questioner-inner">
          <div class="questioner-content full-width-page welcome-cont">
            <div class="question">
              <form class="form-section">
                <h2>Welcome to TTN Fleet Solutions</h2>
                <br>
                <br>
                <div class="row">
                  <div class="col-sm-12 right-part">
                    <div class="wrap-table">
                      <div class="field-row">
                        <div class="field-col full-width">
                          <label class="blue">National Account Preference</label>
                          <input type="text" [disabled]="true" name="national-pref"
                            placeholder="(Default) TTN Fleet Solutions National Account Programs">
                        </div>
                        <div class="field-col full-width">
                          <label class="blue">Service Protocols</label>
                          <p class="grey">
                            Using industry standard protocols for towing, tires and mobile repair by service &
                            subservice utilizing ATA VRMS coding to select best service and pricing solution. View
                            service protocols within client protocol’s section.
                          </p>
                        </div>
                        <div class="field-col full-width">
                          <label class="blue">Communication Protocols</label>
                          <p class="grey">
                            Drivers receive text message of initial engagement, service solution and ETA and any updates
                            during event. Phone calls to drivers for changes to service solution. Email, text and live
                            view for client team members and approvers during live event and phone updates as required
                            or necessary.
                          </p>
                        </div>
                        <div class="field-col full-width">
                          <label class="blue">TTN Contact</label>
                          <p class="grey">
                            <b> TTN Dispatch Line: </b> 888-986-9638 <br>
                            <b> TTN Dispatch Email: </b> dispatch@ttnfs.com<br>
                            <b> Client Experience Team:</b> clients@ttnfs.com<br>
                            <b> Sales Team: </b>sales@ttnfs.com <br>
                          </p>
                        </div>
                      </div>
                    </div>
                    <br>
                  </div>
                </div>
              </form>
            </div>
            <div class="continue">
              <button (click)="showTermsAndConditions();" class="common-btn"> Continue</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </nb-layout-column>
  <nb-layout-footer>
    <ngx-footer></ngx-footer>
  </nb-layout-footer>
</nb-layout>
